import React from "react";

export const Spinner = ({ size }) => {
  return <div className={`lds-dual-ring ${size}`}></div>;
};
